export default __webpack_public_path__ + "static/media/bf.3a2c020a.svg";